var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'faq',
    ("variant-" + _vm.variant) ]},[_c('div',{class:[
      'faq__summary',
      ("variant-" + _vm.variant) ],on:{"click":_vm.onClick}},[_vm._t("header"),_c('div',{class:[
        'faq__toggler',
        ("variant-" + _vm.variant) ]})],2),_c('div',{staticClass:"faq__body"},[_vm._t("main")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }